<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <on-board-top-navbar />
    <section class="section">
      <document-previewer
        :documentTitle="$t(`Draft NDA`)"
        :documentUrl="
          `https://ecobanka-production.s3.eu-west-1.amazonaws.com/nda-draft/${language}.pdf`
        "
      />
      <vue-fab size="big" icon="play_arrow" mainBtnColor="#de4282">
        <fab-item
          @clickItem="showNDAModal()"
          :idx="0"
          color="#409644"
          :title="$t('Aceptar')"
          icon="done"
        />
        <fab-item
          @clickItem="requestConference()"
          :idx="1"
          color="#e87e3c"
          :title="$t('Solicitar información')"
          icon="help"
        />
      </vue-fab>
    </section>
  </div>
</template>

<script>
import OnBoardTopNavbar from '@/components/on-board/OnBoardTopNavbar'
import DocumentPreviewer from '@/components/on-board/DocumentPreviewer'
import NotificationModal from '@/components/on-board/NotificationModal'
import { mapActions, mapGetters } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

function getDate() {
  var today = new Date()
  var dd = String(today.getDate()).padStart(2, '0')
  var mm = String(today.getMonth() + 1).padStart(2, '0')
  var yyyy = today.getFullYear()

  today = mm + '/' + dd + '/' + yyyy
  return today
}

export default {
  mixins: [Fetcher],
  props: ['id'],
  components: {
    DocumentPreviewer,
    OnBoardTopNavbar
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData']),
    language: function() {
      if (this.$i18n.locale == 'es') return 'spanish'
      return 'english'
    }
  },
  data: () => ({
    projectName: ''
  }),
  methods: {
    ...mapActions('onBoard', [
      'postRequestNDASignature',
      'getOnboardRequestDetails',
      'putUpdateOnboardRequest'
    ]),
    showNDAModal: function() {
      let self = this
      self.$dlg.modal(NotificationModal, {
        shaking: false,
        title: false,
        params: {
          title: self.$t('Estimado solicitante'),
          bgColor: '#de4281',
          content: `
                  <div style="text-align: left;">
                  <p>${self.$t('Leer atentamente')}:</p>
                  <br>
                  <p>1º ${self.$t('NDA_PREVIEW_1​')}.</p>
                  <p>2º ${self.$t('NDA_PREVIEW_2')}​.</p>
                  
                   <br>
                  <p>- ${self.$t('NDA_PREVIEW_3')}.</p>
                  <p>- ${self.$t('NDA_PREVIEW_4')}.</p>
                   <br>
                  <p>${self.$t('The Team')}​</p></div>
                  `,
          confirmText: this.$t('Aceptar'),
          closeText: this.$t('Cerrar')
        },
        callback: () => {
          self.requestNDA()
        }
      })
    },
    goToSentNDA(id) {
      this.$router.push({
        name: 'onBoard.neofintech.phase3.sentNDA',
        params: { id: id }
      })
    },
    requestConference: function() {
      let self = this
      self
        .putUpdateOnboardRequest({
          data: { status: 'P3-NDA-REJECTED' },
          requestId: self.neofintechData.requestId
        })
        .then(() => {
          window.open(
            'https://myneofintech.com/myneofintech/conference/',
            '_blank'
          )
        })
    },
    requestNDA: function() {
      let self = this
      self.request(() =>
        self
          .postRequestNDASignature({
            name: self.neofintechData.userData.firstName,
            email: self.neofintechData.email,
            ccRecipients: self.neofintechData.ccRecipients,
            requestId: self.neofintechData.requestId,
            data: {
              date_input: getDate(),
              client_names: `${self.neofintechData.userData.firstName} ${self.neofintechData.userData.lastName}`,
              client_address: `${self.neofintechData.userData.jobCity} / ${self.neofintechData.userData.jobCountry}`,
              company_name: self.neofintechData.userData.companyName,
              ecobanka_date: getDate(),
              project_name: self.projectName,
              client_name: `${self.neofintechData.userData.firstName} ${self.neofintechData.userData.lastName}`,
              client_title: self.neofintechData.userData.jobPosition,
              client_date: getDate()
            }
          })
          .then(function() {
            self.$toast.open({
              message: self.$t('Se ha enviado el NDA a  su correo'),
              type: 'success',
              duration: 15000
            })
            self.goToSentNDA(self.neofintechData.requestId)
          })
      )
    }
  },
  beforeMount() {},
  mounted: function() {
    let self = this
    self.projectName = decodeURIComponent(
      escape(window.atob(self.$route.query.projectName))
    )
    self.request(() =>
      self.getOnboardRequestDetails(this.id).then(function(response) {
        self.$store.commit('onBoard/SET_NEOFINTECH_GENERAL', response.data)
      })
    )
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>

<style>
#app {
  overflow: scroll !important;
}

.fab-main-container {
  bottom: 6% !important;
}

.fab {
  cursor: pointer;
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
}
.fab:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
</style>
